import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useDevicesApi } from '../../../../common/hooks/use-devices-api.hook';
import { DeviceSessionsView } from '../../../seats/components/DeviceSessionsView';

/**
 * Support's view of a vendor's seats: who is signed in where, and a way to
 * sign a device out when a vendor is locked out of their own seats. The seat
 * limit itself is set on the plan or in the plan overrides.
 *
 * DeviceSessionsView draws its own cards, so this adds a heading, not a card.
 */
export function VendorDevicesPanel({ vendorId }: { vendorId: string }) {
  const { t } = useTranslation();
  const api = useDevicesApi();
  const load = useCallback(() => api.getVendorOverview(vendorId), [api, vendorId]);
  const revoke = useCallback((id: string) => api.revokeForVendor(vendorId, id), [api, vendorId]);

  return (
    <section className="flex flex-col gap-4" data-testid="vendor-devices-panel" aria-labelledby="vendor-devices-title">
      <div>
        <h2 id="vendor-devices-title" className="text-sm font-medium">{t('SEATS.ADMIN.TITLE')}</h2>
        <p className="mt-0.5 text-xs text-muted-foreground">{t('ADMIN_VENDOREDIT.DEVICES.SUBTITLE')}</p>
      </div>
      <DeviceSessionsView load={load} revoke={revoke} compact />
    </section>
  );
}
